// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2nQPP","col":"Table_col__1szyd","fulfillmentStatus":"Table_fulfillmentStatus__2rgY_","emailCol":"Table_emailCol__Ngl_b"};